import { render, staticRenderFns } from "./TransactionAttachments.vue?vue&type=template&id=0364e752&"
import script from "./TransactionAttachments.vue?vue&type=script&lang=js&"
export * from "./TransactionAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports